import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Sticky as ReactSticky } from 'react-sticky';

import type { IStickyDeps, IStickyProps } from './models';
import { Sticky as Component } from './sticky';
import styles from './styles.css';

export const Sticky = createWidget<IStickyDeps, IStickyProps>({
    ReactSticky,
    styles,
})(Component);
